(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- cart drawer ---------- */
  function openCart() { var d = $('#tf-drawer'); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeCart() { var d = $('#tf-drawer'); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function refreshCart() {
    return fetch(window.tf.root + '?sections=tf-cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var doc = new DOMParser().parseFromString(j['tf-cart-drawer'], 'text/html');
      var np = doc.querySelector('.tf-drawer__p'), op = $('.tf-drawer__p');
      if (np && op) op.innerHTML = np.innerHTML;
      return fetch(window.tf.cart + '.js').then(function (r) { return r.json(); });
    }).then(function (c) {
      $$('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
    });
  }
  function changeLine(line, qty) {
    return fetch(window.tf.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function () { if (document.body.classList.contains('template-cart')) { location.reload(); return; } return refreshCart(); });
  }
  function addItems(items) {
    return fetch(window.tf.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Kunne ikke lægge varen i kurven'); return j; }); })
      .then(function () { return refreshCart(); }).then(openCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var hd = $('[data-header]');
    if (hd && t === hd && hd.classList.contains('is-open')) { hd.classList.remove('is-open'); return; }
    if (t.closest('[data-burger]')) { hd.classList.toggle('is-open'); return; }
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    var line = t.closest('[data-line]');
    if (line) {
      var idx = +line.getAttribute('data-line');
      var q = t.closest('[data-qty]');
      if (q) { var cur = +$('.tf-qty span', line).textContent; changeLine(idx, Math.max(0, cur + (+q.getAttribute('data-qty')))); return; }
      if (t.closest('[data-remove]')) { changeLine(idx, 0); return; }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); $$('.tf-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); }); } });

  /* ---------- slider ---------- */
  $$('[data-slider]').forEach(function (s) {
    var tr = $('[data-track]', s), bar = $('[data-bar]', s), pv = $('[data-prev]', s), nx = $('[data-next]', s);
    function step() { var c = tr.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : tr.clientWidth * 0.8; }
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth;
      pv.disabled = tr.scrollLeft <= 2; nx.disabled = tr.scrollLeft >= max - 2;
      if (bar) { var w = Math.min(100, tr.clientWidth / tr.scrollWidth * 100); bar.style.width = w + '%'; bar.style.left = (max > 0 ? tr.scrollLeft / max * (100 - w) : 0) + '%'; }
    }
    pv.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    nx.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  });

  /* ---------- product ---------- */
  $$('[data-pdp]').forEach(function (root) {
    var mode = root.getAttribute('data-mode');
    var sizePos = +root.getAttribute('data-size-pos'), colorPos = +root.getAttribute('data-color-pos');
    var single = root.getAttribute('data-single') === 'true';
    var variants = JSON.parse($('[data-pvariants]', root).textContent);
    var msg = $('[data-msg]', root), atc = $('[data-atc]', root);
    function say(t) { msg.textContent = t || ''; }

    $$('[data-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-thumb');
        $$('[data-slide]', root).forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === i); });
        $$('[data-thumb]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
      });
    });

    var modal = $('[data-modal]', root), size = null;
    var selSize = $('[data-sel-size]', root);
    function selectSize(v) {
      size = v;
      if (selSize) selSize.textContent = v;
      $$('.tf-size[data-opt="' + sizePos + '"]', root).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-value') === v); });
      say('');
    }
    if (modal) {
      var kind = modal.getAttribute('data-kind') || 'shirt';
      var guide = $('[data-guide]', root);
      var ans = { belly: '', shoulders: '' }, cur = { height: 175, weight: 80 };
      var order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
      var pantsOrder = ['S', 'M', 'L', 'XL', 'XXL', '3XL'];
      var waists = { S: 78, M: 82, L: 86, XL: 90, XXL: 94, '3XL': 98 };
      var conf = {
        XS: 'Den mindste størrelse i vores sortiment – passer til slanke kropsbygninger.', S: 'De fleste mænd med din kropsbygning går i denne størrelse.', M: 'De fleste mænd med din kropsbygning går i denne størrelse.',
        L: 'De fleste mænd med din kropsbygning går i denne størrelse.', XL: 'De fleste mænd med din kropsbygning går i denne størrelse.',
        '2XL': 'En større pasform – de fleste mænd med en bred bygning går i denne størrelse.', '3XL': 'En større pasform – de fleste mænd med en bred bygning går i denne størrelse.',
        '4XL': 'Oversize-pasform til høje mænd og mænd med bred kropsbygning.', '5XL': 'Den største størrelse i vores sortiment – rummelig oversize-pasform.'
      };
      var go = function (n) { $$('[data-step]', modal).forEach(function (s) { s.classList.toggle('is-on', +s.getAttribute('data-step') === n); }); modal.scrollTop = 0; };
      var paintRange = function (inp) {
        var p = (inp.value - inp.min) / (inp.max - inp.min) * 100;
        inp.style.background = 'linear-gradient(to right,#1a1a1a ' + p + '%,#d4d4d4 ' + p + '%)';
      };
      $$('.tf-range', modal).forEach(function (inp) {
        var q = inp.getAttribute('data-q'), out = $('[data-val="' + q + '"]', modal);
        paintRange(inp);
        inp.addEventListener('input', function () {
          cur[q] = +inp.value; out.textContent = inp.value; paintRange(inp);
          if (q === 'weight') { var max = +inp.value >= +inp.max; $('[data-over]', modal).hidden = !max; if (max) out.textContent = inp.max + '+'; }
        });
      });
      var vals = function () { return $$('.tf-size[data-opt="' + sizePos + '"]', root).map(function (b) { return b.getAttribute('data-value'); }); };
      var fit = function (pick, list) {
        var v = vals();
        if (v.indexOf(pick) >= 0) return pick;
        if (pick === 'XXL' && v.indexOf('2XL') >= 0) return '2XL';
        if (pick === '2XL' && v.indexOf('XXL') >= 0) return 'XXL';
        return v.length ? v[Math.min(v.length - 1, Math.round(list.indexOf(pick) / (list.length - 1) * (v.length - 1)))] : pick;
      };
      var calc = function () {
        var out = {};
        if (kind === 'pants') {
          var waist = 40 + cur.weight * 0.58;
          if (ans.belly === 'flat') waist -= 2; else if (ans.belly === 'round') waist += 3;
          var pi = Math.max(0, Math.min(pantsOrder.length - 1, Math.round((waist - 78) / 4)));
          out.size = fit(pantsOrder[pi], pantsOrder); out.label = 'Taljevidde';
          out.meas = waists[pantsOrder[pi]] + ' cm'; out.conf = 'De fleste mænd med din kropsbygning går i denne størrelse.';
          return out;
        }
        var chest = cur.height * 0.31 + cur.weight * 0.48 + 6;
        if (ans.belly === 'flat') chest -= 2; else if (ans.belly === 'round') chest += 3;
        var garment = chest + 12;
        if (ans.shoulders === 'narrow') garment -= 2; else if (ans.shoulders === 'broad') garment += 3;
        var collar = Math.max(40, Math.min(48, Math.round(40 + (garment - 104) / 4)));
        var base = order[collar - 40];
        out.size = fit(base, order); out.label = 'Kravevidde'; out.meas = collar; out.conf = conf[base];
        return out;
      };
      var show = function () {
        var r = calc();
        $('[data-result]', modal).textContent = r.size; $('[data-apply-size]', modal).textContent = r.size;
        $('[data-conf]', modal).textContent = r.conf; $('[data-meas-label]', modal).textContent = r.label; $('[data-meas]', modal).textContent = r.meas;
        go(5);
      };
      var open = function () {
        ans = { belly: '', shoulders: '' };
        $$('.tf-opts button', modal).forEach(function (b) { b.classList.remove('is-on'); });
        $$('[data-need]', modal).forEach(function (b) { b.disabled = true; });
        go(1); modal.classList.add('is-open');
      };
      if (kind === 'pants') $('[data-step="3"] [data-next]', modal).textContent = 'Se min størrelse';
      $$('[data-open-size]', root).forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-modal-close]', root).forEach(function (b) { b.addEventListener('click', function () { var m = b.closest('.tf-modal'); if (m) m.classList.remove('is-open'); }); });
      $$('[data-next]', modal).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = +b.closest('[data-step]').getAttribute('data-step');
          if (n === 4 || (n === 3 && kind === 'pants')) { show(); return; }
          go(n + 1);
        });
      });
      $$('[data-back]', modal).forEach(function (b) { b.addEventListener('click', function () { go(+b.closest('[data-step]').getAttribute('data-step') - 1); }); });
      $$('.tf-opts', modal).forEach(function (c) {
        c.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          $$('button', c).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          ans[c.getAttribute('data-q')] = b.getAttribute('data-v');
          var nb = $('[data-need]', c.closest('[data-step]')); if (nb) nb.disabled = false;
        });
      });
      $$('[data-open-guide]', modal).forEach(function (b) { b.addEventListener('click', function () { if (guide) guide.classList.add('is-open'); }); });
      if (guide) $$('[data-unit]', guide).forEach(function (b) {
        b.addEventListener('click', function () {
          var u = b.getAttribute('data-unit');
          $$('[data-unit]', guide).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          $$('[data-table]', guide).forEach(function (t) { t.hidden = t.getAttribute('data-table') !== u; });
        });
      });
      $('[data-restart]', modal).addEventListener('click', function () { open(); });
      $('[data-apply]', modal).addEventListener('click', function () {
        var v = $('[data-result]', modal).textContent;
        var btn = $$('.tf-size[data-opt="' + sizePos + '"]', root).filter(function (b) { return b.getAttribute('data-value') === v; })[0];
        if (btn) btn.click();
        modal.classList.remove('is-open');
      });
    }

    function findVariant(sel) {
      return variants.filter(function (v) { return sel.every(function (s, i) { return !s || v.o[i] === s; }); })[0];
    }

    if (mode === 'bundle') {
      var tier = 3, qty = {};
      var cards = $$('.tf-col', root), tot = $('[data-total]', root), selTier = $('[data-sel-tier]', root);
      var total = function () { return Object.keys(qty).reduce(function (a, k) { return a + qty[k]; }, 0); };
      var paint = function () {
        var t = total();
        tot.textContent = '(Valgt: ' + t + '/' + tier + ')'; tot.classList.toggle('is-ok', t === tier);
        cards.forEach(function (c) { var n = qty[c.getAttribute('data-color')] || 0; $('[data-cqty]', c).textContent = n; c.classList.toggle('is-on', n > 0); });
      };
      $$('.tf-size[data-opt="' + sizePos + '"]', root).forEach(function (b) { b.addEventListener('click', function () { selectSize(b.getAttribute('data-value')); }); });
      $$('[data-tier]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          tier = +b.getAttribute('data-tier');
          if (selTier) selTier.textContent = b.getAttribute('data-name');
          $$('[data-tier]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          var keys = Object.keys(qty).reverse();
          while (total() > tier && keys.length) { var k = keys[0]; if (qty[k] > 0) qty[k]--; else keys.shift(); }
          say(''); paint();
        });
      });
      cards.forEach(function (c) {
        var col = c.getAttribute('data-color');
        $('[data-cplus]', c).addEventListener('click', function () { if (total() < tier) { qty[col] = (qty[col] || 0) + 1; say(''); paint(); } });
        $('[data-cminus]', c).addEventListener('click', function () { if ((qty[col] || 0) > 0) { qty[col]--; say(''); paint(); } });
      });
      paint();
      atc.addEventListener('click', function () {
        if (!size) { say('Vælg din størrelse.'); var s = $('[data-sizes]', root); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (total() !== tier) { say('Vælg ' + tier + ' stk. (' + total() + '/' + tier + ').'); return; }
        var items = [];
        for (var k in qty) {
          if (!qty[k]) continue;
          var pick = []; pick[sizePos - 1] = size; pick[colorPos - 1] = k;
          var v = findVariant(pick);
          if (!v || !v.a) { say(k + ' i ' + size + ' er udsolgt.'); return; }
          items.push({ id: v.id, quantity: qty[k] });
        }
        atc.disabled = true; say('');
        addItems(items).then(function () { qty = {}; paint(); }).catch(function (err) { say(err.message); }).then(function () { atc.disabled = false; });
      });
    } else {
      var sel = [];
      $$('.tf-size', root).forEach(function (b) {
        var p = +b.getAttribute('data-opt') - 1;
        if (b.classList.contains('is-on')) sel[p] = b.getAttribute('data-value');
        b.addEventListener('click', function () {
          sel[p] = b.getAttribute('data-value');
          $$('.tf-size[data-opt="' + (p + 1) + '"]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          say('');
        });
      });
      atc.addEventListener('click', function () {
        var v = single ? variants[0] : findVariant(sel);
        if (!v) { say('Vælg størrelse og farve.'); return; }
        if (!v.a) { say('Udsolgt.'); return; }
        atc.disabled = true; say('');
        addItems([{ id: v.id, quantity: 1 }]).catch(function (err) { say(err.message); }).then(function () { atc.disabled = false; });
      });
    }
  });
})();